import { createClient } from '@supabase/supabase-js';
import { createShowcaseClient, isShowcaseMode } from '../showcase-db';
const url=import.meta.env.VITE_SUPABASE_URL as string|undefined;
const key=import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string|undefined;
export const configured=Boolean(url&&key&&!url.includes('VOTRE-PROJET'));

// En local uniquement, un nom de session dans l'URL permet d'ouvrir plusieurs
// profils de démonstration dans le même navigateur sans qu'ils se déconnectent.
// En production, Supabase conserve sa clé de stockage standard.
const localHost=typeof window!=="undefined"&&["localhost","127.0.0.1"].includes(window.location.hostname);
const requestedSession=localHost?new URLSearchParams(window.location.search).get("session"):null;
const safeSession=requestedSession?.match(/^[a-z0-9_-]{1,24}$/i)?.[0];
const storageKey=safeSession?`ard-manager-auth-${safeSession}`:undefined;
const persistencePreferenceKey="ard-manager-auth-persistence";
const shouldRememberSession=()=>typeof window==="undefined"||window.localStorage.getItem(persistencePreferenceKey)!=="session";
const authStorage=typeof window==="undefined"?undefined:{
  getItem(key:string){
    return (shouldRememberSession()?window.localStorage:window.sessionStorage).getItem(key);
  },
  setItem(key:string,value:string){
    const preferred=shouldRememberSession()?window.localStorage:window.sessionStorage;
    const other=shouldRememberSession()?window.sessionStorage:window.localStorage;
    other.removeItem(key);
    preferred.setItem(key,value);
  },
  removeItem(key:string){
    window.localStorage.removeItem(key);
    window.sessionStorage.removeItem(key);
  },
};

export function setAuthSessionPersistence(remember:boolean){
  if(typeof window==="undefined") return;
  window.localStorage.setItem(persistencePreferenceKey,remember?"local":"session");
}

export function getAuthSessionPersistence(){
  return shouldRememberSession();
}

const liveClient=configured?createClient(url!,key!,{
  auth:{
    persistSession:true,
    autoRefreshToken:true,
    detectSessionInUrl:true,
    ...(authStorage?{storage:authStorage}:{}),
    ...(storageKey?{storageKey}:{}),
  },
}):null;

// Showcase redirects every business read/write to a browser-only dataset.
// Its UI supplies a local demonstration identity, so it never needs to open or
// alter a real authentication session.
export const supabase=isShowcaseMode
  ? createShowcaseClient(liveClient)
  : liveClient;
